export default "__VITE_ASSET__DskYtjoD__"